import ApiFactory from '../api/ApiFactory';
import ErrorUtil from '../util/ErrorUtil';

class Service {
    getApiFactory() {
        return ApiFactory.getInstance();
    }

    getAdvogadoSustentacaoOralApi() {
        return this.getApiFactory().getAdvogadoSustentacaoOralApi();
    }

    getLoginApi() {
        return this.getApiFactory().getLoginApi();
    }

    getProcessoApi() {
        return this.getApiFactory().getProcessoApi();
    }

    getSessaoApi() {
        return this.getApiFactory().getSessaoApi();
    }

    getPautaApi() {
        return this.getApiFactory().getPautaApi();
    }

    getPecasApi() {
        return this.getApiFactory().getPecasApi();
    }

    getCertidaoApi() {
        return this.getApiFactory().getCertidaoApi();
    }

    getAcordaoApi() {
        return this.getApiFactory().getAcordaoApi();
    }

    getMovimentoCNJApi() {
        return this.getApiFactory().getMovimentoCNJApi();
    }

    getAnotacaoApi() {
        return this.getApiFactory().getAnotacaoApi();
    }

    getAssinaturaApi() {
        return this.getApiFactory().getAssinaturaApi();
    }

    getSecretariaApi() {
        return this.getApiFactory().getSecretariaApi();
    }

    getHealthCheckApi() {
        return this.getApiFactory().getHealthCheckApi();
    }

    getVersaoOrigemApi() {
        return this.getApiFactory().getVersaoOrigemApi();
    }

    getClienteEnvelopeApi() {
        return this.getApiFactory().getClienteEnvelopeApi();
    }

    getFotoMagistradoApi() {
        return this.getApiFactory().getFotoMagistradoApi();
    }

    getTipoJulgamentoApi() {
        return this.getApiFactory().getTipoJulgamentoApi();
    }

    getValidacaoPreSessaoApi() {
        return this.getApiFactory().getValidacaoPreSessaoApi();
    }

    getCalendarioApi() {
        return this.getApiFactory().getCalendarioApi();
    }

    isRespostaSucesso(response) {
        return this.isStatusRespostaSucesso(response) && !this.isTipoRespostaErro(response);
    }

    isStatusRespostaSucesso(response) {
        return response && response.status && (response.status + '').startsWith('2');
    }

    isTipoRespostaErro(response) {
        return (
            response &&
            response.data &&
            (Array.isArray(response.data) && response.data.length > 0 && response.data[0]
                ? response.data.findIndex((r) => r.tipo === 'ERRO') !== -1
                : response.data.tipo === 'ERRO')
        );
    }

    async processarOperacaoLote(funcaoOperacao, registro) {
        let resultadoProcessamento;

        try {
            let response = await funcaoOperacao();

            if (this.isRespostaSucesso(response)) {
                resultadoProcessamento = {
                    numeroProcesso: registro.processo.numeroCompleto
                };
            } else {
                resultadoProcessamento = ErrorUtil.getResultadoProcessamentoErroServico(
                    response,
                    registro.processo.numeroCompleto
                );
            }
        } catch (error) {
            resultadoProcessamento = ErrorUtil.getResultadoProcessamentoErro(error, registro.processo.numeroCompleto);
        }

        return resultadoProcessamento;
    }
}

export default Service;
